<template>
  <view class="radio-modal-default-demo">
    <cube-checkbox-group-modal
      wx:ref="checkboxModal"
      title="我是标题"
      subtitle="这里是描述这里是描述这里是描述这里是描述这里是描述这里是描述这里是描述这里是描述这里是描述"
      show-close-icon="{{ true }}"
      options="{{ options }}"
      values="{{ value }}"
      bind:close="onClose"
      bind:confirm="onConfirm"
    />
    <cube-button bindclick="onTap">checkbox-modal-option-conf</cube-button>
  </view>
</template>

<script>
  import { createComponent } from '@mpxjs/core'

  createComponent({
    data: {
      confirmBtn: '确认支付方式',
      options: [
        {
          value: '1',
          position: 'right',
          disabled: true,
          text: '企业支付',
          desc: ''
        },
        {
          value: '2',
          text: '亲友代付',
          position: 'right',
          desc: '仅支持滴滴快车/优享/舒适型/豪华车型'
        },
        {
          value: '3',
          text: '个人支付',
          position: 'right',
          desc: '仅支持滴滴快车/优享/舒适型/豪华车型仅支持滴滴快车/优享/舒适型/豪华车型'
        }
      ],
      value: ['2', '3']
    },
    methods: {
      onTap() {
        this.$refs.checkboxModal.show()
      },
      onConfirm(args) {
        console.log('当前选择的值是', args.detail)
      },
      onClose(args) {
        console.log('当前取消前选择的值是', args.detail)
      }
    }
  })
</script>

<style lang="stylus">
</style>

<script type="application/json">
  {
    "usingComponents": {
      "cube-checkbox-group-modal": "@mpxjs/mpx-cube-ui/src/components/checkbox-modal/index.mpx",
      "cube-button": "@mpxjs/mpx-cube-ui/src/components/button/index.mpx"
    }
  }
</script>
